<div class="filters_view_bg" [hidden]="!showHideColumnDropdown" (click)="showHideColumnDropdown = false"></div>
<p-table [value]="data" [resizableColumns]="true" columnResizeMode="expand" [responsiveLayout]="'scroll'" [tableStyle]="{ width: '100%' }" [scrollable]="true"
    scrollHeight="400px" [(selection)]="selectedRows">
    <ng-template pTemplate="header">
        <tr>
            <!-- <th class="position-relative">
                <span (click)="showHideColumnDropdown = !showHideColumnDropdown">
                    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg> 
                </span>
                <div class="column-dropdown-container" *ngIf="showHideColumnDropdown">
                    <div class="mb-2">
                        <label>
                        <input type="checkbox" class="form-check-input mr-3" [(ngModel)]="selectAll" (change)="toggleAllColumns()"style="cursor: pointer;"
                        >
                        <span>Select All</span>
                    </label>
                   </div>
                    <ul *ngFor="let column of allcolumns; let columnIndex = index">
                        <li class="d-flex">
                            <label for="{{column.header}}_{{columnIndex}}">
                                <input type="checkbox" class="form-check-input mr-3" id="{{column.header}}_{{columnIndex}}" [(ngModel)]="column.showColumn" style="cursor: pointer;"
                                (change)="toggleColumnVisibility()">
                                <span>{{column.header}}</span>
                            </label>
                        </li>
                    </ul>
                </div>
            </th> -->
            <th *ngIf="tableName != 'roleTable'">
                <p-checkbox [(ngModel)]="isAllSelected" [binary]="true" (onChange)="toggleSelectAll()"></p-checkbox>
            </th>
            <th pResizableColumn *ngFor="let column of columns; let columnIndex = index" [ngClass]="{'d-none': !column.showColumn} "
                (click)="column.sortable ? sortData(columnIndex, column.key) : null" [class.sortable]="column.sortable">
                {{ column.header }}
                <span class="svg-sort" *ngIf="column?.sortable"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span>
                <!-- <span *ngIf="sortedColumnIndex === columnIndex">
                    <i class="pi"
                        [ngClass]="{'pi-sort-amount-up': sortOrder === 'ASC', 'pi-sort-amount-down': sortOrder === 'DESC'}"></i>
                </span> -->
            </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
        <tr style="cursor: pointer;">
            <!-- <td style="width: 40px;">

            </td> -->
            
            
            <td  *ngIf="tableName != 'roleTable'">
                <p-checkbox class="form-check-input" [(ngModel)]="row.selected" (onChange)="onRowSelect(row)"
                [binary]="true"></p-checkbox>
            </td>
            
            <td *ngFor="let column of columns; let columnIndex = index" [ngClass]="
            {
                'd-none': !column.showColumn,
                'overrun-class': row?.invoiceStatus === 'OVERRUN' && column.key === 'invoiceStatus',
                'lightgreen': row?.approvalStatus === 'PARTIALLY_APPROVED' && column.key === 'approvalStatus'
            }">
            <ng-container *ngIf="column.type ==='action'" >
                <td *ngIf="actionOnOrderRecord(row)">
                    <button class="btn btn-primary ms-2">Accept</button>
                    <button class="btn btn-danger">Reject</button>
                </td>
            </ng-container>

            <ng-container *ngIf="column.type === 'roleaction'">
                <span (click)="onRowSelect(row)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#313131"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z" stroke="#313131" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13" stroke="#313131" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                </span>
            </ng-container>
                <ng-container *ngIf="column.type === 'dropdown'">
                    <p-dropdown [options]="dropdownOptions[column.key]" [(ngModel)]="row[column.key]"></p-dropdown>
                </ng-container>

                <ng-container *ngIf="column.type === 'input'">
                    <input pInputText [(ngModel)]="row[column.key]" class="form-control" />
                </ng-container>
                
                <ng-container *ngIf="column.type === 'date'">
                    {{row[column.key] | CustomDatePipe: ''}}
                    <!-- <p-calendar [(ngModel)]="row[column.key]" [showIcon]="true"></p-calendar> -->
                </ng-container>

                <ng-container *ngIf="column.type === 'invoicedate'">
                    {{row[column.key] | CustomDatePipe: 'D-M-YYYY'}}
                    <!-- <p-calendar [(ngModel)]="row[column.key]" [showIcon]="true"></p-calendar> -->
                </ng-container>

                

                <ng-container *ngIf="column.type === 'month'">
                    {{row[column.key] | CustomDatePipe: 'MMMM'}}
                    <!-- <p-calendar [(ngModel)]="row[column.key]" [showIcon]="true"></p-calendar> -->
                </ng-container>

                <ng-container *ngIf="column.type === 'status'">
                    <span >{{ row[column?.key] == 1 ? 'Active':'Inactive' }}</span>
                </ng-container>

                <ng-container *ngIf="column.type === 'policeverify'">
                    <span [ngClass]="
                        {
                            'draft': row[column?.key] === 'NotUploaded',
                            'commentedPill': row[column?.key] === 'PendingForVerification',
                            'errorPill': row[column?.key] === 'Rejected',
                            'successPill': row[column?.key] === 'Approved',
                             
                        }">
                        <ng-container *ngIf="row[column?.key] === 'PendingForVerification'">
                            <span class="cross">
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect x="0" fill="none" width="24" height="24"></rect> <g> <path d="M18.36 19.78L12 13.41l-6.36 6.37-1.42-1.42L10.59 12 4.22 5.64l1.42-1.42L12 10.59l6.36-6.36 1.41 1.41L13.41 12l6.36 6.36z"></path> </g> </g></svg>
                            </span>
                             <span class="tick">
                                <svg fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm5.676,8.237-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,1,1,1.414-1.414l2.323,2.323,5.294-4.853a1,1,0,1,1,1.352,1.474Z"></path></g></svg>
                            </span>
                        </ng-container>
                        <ng-container *ngIf="row[column?.key] !== 'PendingForVerification'">
                            {{ row[column?.key] ? row[column?.key] : 'Not Uploaded' }}
                        </ng-container>
                    </span>
                </ng-container>
                
                <ng-container *ngIf="column.type === 'statusBadge'">
                    <span class="successPill" *ngIf="row[column?.key] == 1">Active</span>
                    <span class="errorPill" *ngIf="row[column?.key] == 0">Inactive</span>
                </ng-container>
                
                <ng-container *ngIf="column.type === 'userRole'">
                    <span *ngFor="let wh of row[column.key]; let last = last">{{wh?.roleDescription}}  <span *ngIf="!last">, </span></span>
                </ng-container>

                <ng-container *ngIf="column.type === 'file'">
                    <div style="text-align: center;">
                      <ng-container *ngFor="let url of row[column.key]?.split(',')">
                        <a [href]="url.trim()" class="file" target="_blank">
                          <svg fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="icon">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                              <path d="M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"></path>
                            </g>
                          </svg>
                        </a>
                      </ng-container>
                    </div>
                  </ng-container>
                
                <ng-container *ngIf="column.type === 'vendorMapping'">
                    <span *ngFor="let wh of row[column.key]; let last = last">{{wh?.vendorName}}  <span *ngIf="!last">, </span></span>
                </ng-container>

                <ng-container *ngIf="column.type === 'RouteDetails'">
                    <span *ngFor="let wh of row[column.key]; let last = last">{{wh?.sourceText}} - {{wh?.destinationText}}  <span *ngIf="!last">, </span></span>
                </ng-container>

                
                 <ng-container *ngIf="column.type === 'accountMapping'">
                    <span *ngFor="let wh of row[column.key]; let last = last">{{wh?.accountName}}  <span *ngIf="!last">, </span></span>
                </ng-container>

                <ng-container *ngIf="column.type === 'text'">
                    <span *ngIf="column.viewDialog" (click)="openRowDetailsDialog(column, row)">
                      <a href="javascript:void(0)">{{ row[column.key] }}</a>
                    </span>
                    <span *ngIf="column.customerviewDialog" (click)="openCustomerDetailsDialog(column, row)">
                      <a href="javascript:void(0)">{{ row[column.key] }}</a>
                    </span>
                   
                    <span *ngIf="column.viewPopup" (click)="openDetailspopUp(column, row)">
                      <a href="javascript:void(0)">{{ row[column.key] }}</a>
                    </span>

                     <ng-container *ngIf="!column.viewDialog && !column.isRedirect && !column.customerviewDialog && !column.viewPopup">
                     <span *ngIf="column.key == 'status'" class=""
                     [ngClass]="
                     {
                        'draft': row[column.key] == 'Draft',
                        'PendingOnVendor': row[column.key] == 'PendingOnVendor',
                        'primaryPill': row[column.key] == 'Created' ||  row[column.key] == 'Closed',
                        'commentedPill': row[column.key] == 'PendingOnCustomer',
                        'successPill': row[column.key] == 'AcceptedByVendor' || row[column.key] == 'AcceptedByCustomer' || row[column.key] == 'Completed',
                        'errorPill': row[column.key] == 'Cancel'|| row[column.key] == 'RejectedByVendor' || row[column.key] == 'RejectedByCustomer' || row[column.key] == 'Expire',
                    }"
>
<!-- row[column.key] == 'RejectedByVendor' ? 'errorPill':'primaryPill'" -->
                        {{getStatusText(row[column.key])}}
                     </span>
                     <span *ngIf="column.key !== 'status'">
                         {{ getDisplayValue(row[column.key]) }}
                     </span>
                     </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="23" rowspan="5" style="color: red;padding: 30px;">Not found.</td>
        </tr>
      </ng-template>
</p-table>